import React, { useState, useEffect, useRef, useContext } from 'react';
import { coreAxios } from "utilities/axios";
import { classNames } from 'primereact/utils';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { Rating } from 'primereact/rating';
import { Toolbar } from 'primereact/toolbar';
import { InputTextarea } from 'primereact/inputtextarea';
import { RadioButton } from 'primereact/radiobutton';
import { InputNumber } from 'primereact/inputnumber';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { FiSearch } from "react-icons/fi";
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { CommonButton } from "components/Buttons/Buttons";
import { MasterButton } from "components/Buttons/MasterButton";
import  DeleteModalTwo  from "components/Modal/DeleteModalTwo";
import { Image } from 'primereact/image';
import { Galleria } from 'primereact/galleria';

//NEW
import AuthContext from  "../../context/AuthContext";
import { InputField } from "components/InputField/Input";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { Report } from 'services/report/report.service'
import { Table } from 'components/Table/Table';
import { NameColumn, TextColumn } from 'components/Table/ColumnTemplates/CustomColumn';

const BASE_URL = process.env.REACT_APP_MAIN_URL

const Reportt = () => {

    const { reportList, reportListLoading } = useSelector((state) => state.reportList);


    const [autoReportFilteredValue, setAutoReportFilteredValue] = useState([]);

    const [date, setDate] =useState(new Date());

    const [showForm, setShowForm] = useState(false); //* state for form modal

    const [updateData, setUpdateData] = useState(null); // * state for update data
    const { user } = useContext(AuthContext);

    const ref = useRef(null);
    // * intitial value for create division state
    const createInitialValue = {
        id: 0,
        start_date: date,
        end_date: date,
        employee_id: '',
        report_type: '',
    };

    const formik = useFormik({
        initialValues: createInitialValue, // * if state is update then updateData state value will show up
        // validationSchema: LandValidationSchema, // * yup schema validation
        onSubmit: (values) => {
            handelSubmit(values);
        },
        enableReinitialize: true,
    });


    const [selectedData, setSelectedData] = useState([])
    const dispatch = useDispatch();

    // form submit handler
    const handelSubmit = async (data) => {

        await dispatch(Report(data)).then(() => {
            hideModal();
            return
        });
    };


    // modal hide function
    const hideModal = () => {
        setUpdateData(null); // * set updateData state to null to get latest update after when press again
        resetForm(); // * reset the form state
    };

    // reset form function
    const resetForm = () => {
        formik.resetForm();
    };

    useEffect(() => {
        dispatch(Report({
            id: 0,
            start_date: date,
            end_date: date,
            employee_id: '',
            report_type: {"name": "", "label": ""},
        }))
    }, []);



    // columns of the table with header name

    const tableAccountReportColumns = [
        { field: "emp_code", header: "Employee ID", sortableBody: NameColumn },
        { field: "emp_name", header: "Employee Name", sortableBody: NameColumn },
        { field: "designation", header: "Designation", sortableBody: NameColumn },
        { field: "unit", header: "Unit", sortableBody: NameColumn },
        { field: "total_price", header: "Total Price", sortableBody: TextColumn },
    ];
    const tableChalanReportColumns = [
        { field: "name", header: "Chalan No", sortableBody: NameColumn },
        { field: "work_order_name", header: "Work Order No", sortableBody: NameColumn },
        { field: "date", header: "Date", sortableBody: NameColumn },
        { field: "supplier", header: "Supplier", sortableBody: TextColumn },
        { field: "total_buy_price", header: "Total buy Price", sortableBody: TextColumn },
        { field: "total_sell_price", header: "Total sell Price", sortableBody: TextColumn },
        { field: "net_profit", header: "Net Profit", sortableBody: TextColumn },
    ];

    const tableSalesReportColumns = [
        { field: "invoice_no", header: "Invoice No", sortableBody: NameColumn },
        { field: "emp_code", header: "Employee Code", sortableBody: NameColumn },
        { field: "date", header: "Date", sortableBody: NameColumn },
        { field: "time", header: "Time", sortableBody: TextColumn },
        { field: "total_price", header: "Total Price", sortableBody: TextColumn },
    ];

    const tableStockReportColumns = [
        { field: "name", header: "Stock Name", sortableBody: NameColumn },
        { field: "code", header: "Stock Code", sortableBody: NameColumn },
        { field: "uom", header: "UOM", sortableBody: NameColumn },
        { field: "stock_quantity", header: "Stock Quantity", sortableBody: TextColumn },
        { field: "sell_quantity", header: "Sell Quantity", sortableBody: TextColumn },
        { field: "remain_quantity", header: "Remain Quantity", sortableBody: TextColumn },
        { field: "rate", header: "Rate", sortableBody: TextColumn },
        { field: "total_stock_price", header: "Total Stock Price", sortableBody: TextColumn },
    ];

    const reportTypes =  [
        {"name": "account_report", "label": "Account Report"},
        {"name": "chalan_report", "label": "Chalan Report"},
        {"name": "sales_report", "label": "Sales Report"},
        {"name": "stock_report", "label": "Stock Report"},
    ]

    const searchReportType = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length && reportTypes !== undefined) {
                setAutoReportFilteredValue([...reportTypes]);
            } else {
                setAutoReportFilteredValue(
                    reportTypes?.filter((land_name) => {
                        return land_name.name.toLowerCase().startsWith(event.query.toLowerCase());
                    })
                );
            }
        }, 250);
    };

    const handelDeedNo = async (e) => {
        if(e.target.value){
            // await dispatch(LandDeedNo(e.target.value))
        }
    };


    // * input data array of object for the form / modal
    const inputData = [
        {
            id: "start_date",
            name: "start_date",
            value: "start_date",
            type: "date",
            labelFor: "start_date",
            label: "Start Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "end_date",
            name: "end_date",
            value: "end_date",
            type: "date",
            labelFor: "end_date",
            label: "End Date",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "employee_id",
            name: "employee_id",
            value: "employee_id",
            type: "text",
            labelFor: "employee_id",
            label: "Employee Id",
            required: false,
            messagePosition: 'bottom',
            className: "col-12 md:col-2",
        },
        {
            id: "report_type",
            name: "report_type",
            type: "select",
            labelFor: "Select Reports",
            label: "Select Reports",
            className: "col-12 md:col-2",
            autoFilteredValue: autoReportFilteredValue,
            autoCompleteMethod: searchReportType,
            selectedAutoValue: reportTypes,
            onBlur: handelDeedNo,
        },
    ];

    return (
        <>
            <form onSubmit={formik.handleSubmit} ref={ref} className={`grid grid-cols-4 mt-2 gap-x-3`}>
                
                {inputData.map(({ id, name, value, type, labelFor, label, required, rows, className, autoCompleteMethod, autoFilteredValue, onBlur, onChange, errors, ...rest }) => (
                        
                    <div key={id} className={`p-field ${className}`} >
                        <InputField
                            id={id}
                            type={type}
                            required={required}
                            name={name}
                            errors={errors || formik.errors?.[id]?.id || formik.errors[id]}
                            label={label}
                            labelFor={labelFor}
                            rows={rows}
                            value={formik.values[name]}
                            autoCompleteMethod={autoCompleteMethod}
                            autoFilteredValue={autoFilteredValue}
                            onChange={(...args) => {
                                !onChange && formik.handleChange(...args);
                                onChange?.(...args);
                            }}
                            onBlur={onBlur}
                            onClose={() => formik.setErrors({})}
                            {...rest}
                        />
                    </div>
                ))}
                <div className={`p-field col-12 md:col-3`} >
                <Button 
                    type='submit'
                    label='Search'
                    style={{'width': "100%"}}
                    icon={<FiSearch className="text-3xl mr-2" />}
                />
                </div>
                
            </form>
            
            <Table
                //data
                tableHeaderName="Reports"
                tableColumns={reportList.report_type == 'sales_report' ? tableSalesReportColumns : reportList.report_type == 'stock_report' ? tableStockReportColumns : reportList.report_type == 'account_report' ? tableAccountReportColumns : tableChalanReportColumns}
                data={reportList.data}
                loading={reportListLoading}
                dataKey="id"
                rows={25}
                sortable
                searchField
                isRowSelectable
                exportBtn
                hideLeftToolbar
                selectedData = {selectedData}
                setSelectedData = {setSelectedData}
                // actionButton={actionBodyTemplate}
                setShowCreateModal={setShowForm}
            />
        </>
    );
};

export default Reportt;
